export const authorizationServerUrl = 'https://telemetry.blinkelectrics.co.ke/auth';